"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var idm_crosscutting_concepts_frontend_1 = require("@synisys/idm-crosscutting-concepts-frontend");
var utilities_1 = require("./utilities");
var lodash_1 = require("lodash");
var SisControlWithSettings = /** @class */ (function () {
    function SisControlWithSettings() {
    }
    Object.defineProperty(SisControlWithSettings.prototype, "hint", {
        get: function () {
            return this._hint;
        },
        set: function (multilingualString) {
            if (multilingualString instanceof idm_crosscutting_concepts_frontend_1.MultilingualString) {
                this._hint = multilingualString;
            }
            else if (lodash_1.isPlainObject(multilingualString)) {
                var builder_1 = idm_crosscutting_concepts_frontend_1.MultilingualString.newBuilder();
                lodash_1.entries(multilingualString).forEach(function (_a) {
                    var key = _a[0], value = _a[1];
                    builder_1.withValueForLanguage(lodash_1.parseInt(key, undefined), value);
                });
                this._hint = builder_1.build();
            }
            else if (multilingualString) {
                this._hint = utilities_1.stringToMultilingual(multilingualString);
            }
        },
        enumerable: true,
        configurable: true
    });
    SisControlWithSettings.propDecorators = {
        "hint": [{ type: core_1.Input },],
    };
    return SisControlWithSettings;
}());
exports.SisControlWithSettings = SisControlWithSettings;
//# sourceMappingURL=sis-control-with-settings.js.map